module.exports = __webpack_public_path__ + "img/distance.b3ebcfae.svg";